module.exports = __webpack_public_path__ + "static/media/close.f2af80f6.svg";